export class ToDo {
    id!: string
    userId!: string
    name!: string
    isHot!: boolean
    details!: string
    dueDate!: Date
    doneDate!: Date
    isRecurring = false
    recurrenceWeekOfMonth?: number
    recurrenceDayOfWeek?: number
    recurrenceSeriesId?: string
    createdOn!: Date
    lastmodifiedOn!: Date
    createdByid!: string
    lastmodifiedByid!: string

    meetingIds: string[] = []
    userIds: string[] = [] // Multiple user can only be assigned when adding a new ToDo, and multiple ToDos will be created for each user
    meetingName?: string

    // Properties for the Home page
    source?: string
    assignedToDisplayName?: string
    createdByDisplayName?: string
}
